<template>
    <div>

        <div class="update_cc">
            <div v-if="(!locations || locations.length < 1) && locationsHaveBeenLoaded" class="no-locations">
                You do not have any locations associated with your account, please contact: <a href="mailto:jjsupport@theplaylistgeneration.com">jjsupport@theplaylistgeneration.com</a>, or contact the Jimmy Tunes Support Line at: 323-275-9364.<br><br>
                <router-link :to="{ path: '/' }">
                    Return to home page
                </router-link>
            </div>
            <div v-else>
                <form method="post" enctype="multipart/form-data" @submit.prevent="submitForm" class="form-check" :class="{isJj: isJj}" name="zone_form" style="margin-bottom: 0px;height:auto;min-height:auto;">
                    <div class="onboarding-container" style="margin-bottom: 30px;height:auto;min-height:auto;">
                        <div class="row" v-if="locations && locations.length > 1">
                            <div class="alert alert-danger" role="alert" v-if="no_selected_locations">
                                You must select at least one location
                            </div>
                            <h4>Apply this Payment Method to the following locations.</h4>
                            <div class="multi-location-sub">If you are missing a location that should be included under your login, please e-mail <a href="mailto:jjsupport@theplaylistgeneration.com">jjsupport@theplaylistgeneration.com</a>.</div>
                            <div class="select-locations-container" >
                                <div v-for="location in locations" :key="location.id" class="select-locations-row" >
                                    <label class="form-check-label">
                                        <input class="form-check-input"
                                                type="checkbox"
                                                name="location"
                                                v-model="selected_locations"
                                                :value="location.id">
                                        &nbsp;&nbsp;{{location.name}}
                                    </label>
                                </div>
                            </div>

                        </div>

                        <h4>Payment Information</h4>
                        <div style="margin-bottom:15px;padding-left:8px;" ref="topOfForm">
                            <div class="player-update-radios">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input data-creditcardoption
                                                class="form-check-input"
                                                type="radio"
                                                name="cc_or_ach"
                                                v-model="cc_or_ach"
                                                value="creditcard">
                                        &nbsp;&nbsp;Credit Card
                                    </label>
                                </div>
                                <div class="form-check" style="margin-top:10px;">
                                    <label class="form-check-label">
                                                <input data-achoption
                                                        class="form-check-input"
                                                        type="radio"
                                                        name="cc_or_ach"
                                                        v-model="cc_or_ach"
                                                        value="ACH">
                                                &nbsp;&nbsp;ACH
                                            </label>
                                </div>
                            </div>
                        </div>

                        <div v-if="cc_or_ach == 'creditcard'" class="ccOrAch">
                            <div class="form-group workspace-content-form-row row">
                                <div class="col-lg-3">
                                    Name (<span :class="{inlineError:v$.card_first_name.$error,isJj: isJj}">First</span>,<span :class="{inlineError:v$.card_last_name.$error, isJj: isJj}">Last</span>):
                                </div>
                                <div class="col-lg-9">
                                    <div class="">
                                        <div class="col-xs-6" style="padding:0px;padding-right:3px;">
                                            <input name="Card First Name" type="text" v-model="card_first_name" id="card_first_name" data-cardfirstname>
                                        </div>
                                        <div class="col-xs-6" style="padding:0px;padding-left:3px;">
                                            <input type="text" name="Card Last Name" v-model="card_last_name" data-cardlastname>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="form-group workspace-content-form-row row">
                                <div class="col-lg-3 workspace_content_form_row_title" :class="{inlineError:v$.card_type.$error, isJj: isJj}">
                                    Card Type
                                </div>
                                <div class="col-lg-9 workspace_content_form_row_input">
                                    <vue-select close-on-select data-cardtype v-model="card_type" autocomplete="false" name="Card Type" :options="[{'id':'Visa','name':'Visa'},{'id':'MasterCard','name':'Master Card'},{'id':'AmEx','name':'American Express'},{'id':'Discover','name':'Discover'}]"
                                        label-by="name"></vue-select>

                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-lg-3" :class="{inlineError:v$.card_number.$error,isJj: isJj}">Card #</div>
                                <div class="col-lg-9">
                                    <input data-cardnumber type="text" v-model="card_number" name="Card Number" id="card_number">
                                </div>
                            </div>

                            <div class="form-group workspace-content-form-row row">
                                <div class="col-lg-3 workspace_content_form_row_title">
                                    <span :class="{inlineError:v$.expire_month.$error,isJj: isJj}">Exp Month</span>, <span :class="{inlineError:v$.expire_year.$error,isJj: isJj}">Year:</span>
                                </div>
                                <div class="col-lg-9 workspace_content_form_row_input">
                                    <div class="">
                                        <div class="col-xs-6" style="padding:0px;padding-right:3px;">
                                            <vue-select close-on-select data-cardexpmonth v-model="expire_month" autocomplete="false" name="Expiration Month" :options="filteredMonths" label-by="name"></vue-select>
                                        </div>
                                        <div class="col-xs-6" style="padding:0px;padding-left:3px;">
                                            <vue-select close-on-select data-cardexpyear v-model="expire_year" autocomplete="false" name="Expiration Year" :options="expYears" label-by="name"></vue-select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group workspace-content-form-row row">
                                <div class="col-lg-3" :class="{inlineError:v$.card_cvv.$error,isJj: isJj}">
                                    CVV
                                </div>
                                <div class="col-lg-9">
                                    <input data-cardcvv type="text" id="card_cvv" name="Card CVV" v-model="card_cvv">
                                </div>
                            </div>
                        </div>

                        <div v-if="cc_or_ach == 'ACH'">
                            <div class="form-group workspace-content-form-row row">
                                <div class="col-lg-3">
                                    Name (<span :class="{inlineError:v$.ach_first_name.$error,isJj: isJj}">First</span>,<span :class="{inlineError:v$.ach_last_name.$error,isJj: isJj}">Last</span>):
                                </div>
                                <div class="col-lg-9">
                                    <div class="">
                                        <div class="col-xs-6" style="padding:0px;padding-right:3px;">
                                            <input data-achfirstname name="ACH First Name" type="text" v-model="ach_first_name">
                                        </div>
                                        <div class="col-xs-6" style="padding:0px;padding-left:3px;">
                                            <input data-achlastname type="text" name="ACH Last Name" v-model="ach_last_name">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group workspace-content-form-row row">
                                <div class="col-lg-3" :class="{inlineError:v$.routing_number.$error,isJj: isJj}">Routing Number:</div>
                                <div class="col-lg-9">
                                    <input data-achroutingnumber type="text" name="Routing Number" v-model="routing_number" id="routing_number">
                                </div>
                            </div>
                            <div class="form-group workspace-content-form-row row">
                                <div class="col-lg-3" :class="{inlineError:v$.account_number.$error, isJj: isJj}">Account Number:</div>
                                <div class="col-lg-9">
                                    <input data-achaccountnumber type="text" name="Account Number" id="account_number" v-model="account_number">

                                </div>
                            </div>
                            <div class="form-group workspace-content-form-row row">
                                <div class="col-lg-3" :class="{inlineError:v$.account_type.$error,isJj: isJj}">Account Type:</div>
                                <div class="col-lg-9">
                                    <vue-select close-on-select data-achaccounttype v-model="account_type" autocomplete="false" name="Billing Account Type" :options="[{'id':'c','name':'Checking'},{'id':'s','name':'Savings'}]" label-by="name"></vue-select>
                                </div>
                            </div>
                        </div>

                        <br>
                        <h4>Billing Address</h4>

                        <div class="form-group row">
                            <div class="col-lg-3" :class="{inlineError:v$.billing_address.$error,isJj: isJj}">
                                Billing Address:
                            </div>
                            <div class="col-lg-9">
                                <input type="text" name="Billing Address" placeholder="Include Suite, Unit etc" v-model="billing_address">
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-lg-3" :class="{inlineError:v$.billing_city.$error,isJj: isJj}">
                                Billing City:
                            </div>
                            <div class="col-lg-9">
                                <input type="text" name="Billing City" id="billing_city" v-model="billing_city">
                            </div>
                        </div>

                        <div class="form-group row">
                            <!-- v-if="shouldDisplayStates" -->
                            <div class="col-lg-3" :class="{inlineError:v$.billing_state.$error,isJj: isJj}">
                                Billing State:
                            </div>
                            <div class="col-lg-9">
                                <vue-select close-on-select name="Billing State" autocomplete="false" v-model="billing_state" :options="statesOrProvinces" label-by="name" id="state" data-state></vue-select>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-lg-3" :class="{inlineError:v$.billing_postal.$error,isJj: isJj}">
                                Billing Postal:
                            </div>
                            <div class="col-lg-9">
                                <input type="text" name="Billing Postal" v-model="billing_postal" id="billing_postal" data-postal>
                            </div>
                        </div>

                        <br>
                        <h4>Billing Email</h4>

                        <div class="form-group row">
                            <div class="col-lg-3" :class="{inlineError:v$.billing_email.$error,isJj: isJj}">
                                Billing Email:
                            </div>
                            <div class="col-lg-9">
                                <input type="text" name="Billing Email" v-model="billing_email">
                            </div>
                        </div>

                        <div style="width:100%;text-align: center;margin-top:40px;margin-bottom:0px">
                            <button class="clean-grayv form-submit-button" type="submit" style="width:100%;margin-bottom:0px" :disabled="form_has_been_submitted">Submit</button>
                        </div>

                    </div>
                </form>

                <br><br><br><br><br><br><br><br><br><br><br><br><br>

            </div>
        </div>

    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, requiredIf, helpers } from '@vuelidate/validators';

const Querystring = require('querystring');

export default {
  props: ['user-info'],
  inject: ['cwGlobal'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      isJj: true,
      API_LOGIN_ID_SAND: 'CKe8y7YuH',
      API_LOGIN_ID_TPG: 'yAV0Fc00p7',
      errorString: '',
      locationsHaveBeenLoaded: false,
      cc_or_ach: 'creditcard',
      card_first_name: '',
      card_last_name: '',
      card_number: '',
      card_type: null,
      expire_year: null,
      expire_month: null,
      card_cvv: '',
      account_number: '',
      routing_number: '',
      account_type: null,
      ach_first_name: '',
      ach_last_name: '',
      billing_email: '',
      billing_address: '',
      billing_city: '',
      billing_country: { id: 1, name: 'United States of America' },
      billing_state: '',
      billing_postal: '',
      one_time_token: '',
      statesAndProvinces: [],
      statesOrProvinces: [],
      countries: [],
      form_has_been_submitted: false,
      selected_locations: [],
      no_selected_locations: false,
      locations: [],
    };
  },
  validations() {
    return {
      card_first_name: {
        required: helpers.withMessage('Card first name is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      card_last_name: {
        required: helpers.withMessage('Card last name is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      card_type: {
        required: helpers.withMessage('Card type is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      card_number: {
        required: helpers.withMessage('Card number is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      expire_month: {
        required: helpers.withMessage('Expiration month is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      expire_year: {
        required: helpers.withMessage('Expiration year is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      card_cvv: {
        required: helpers.withMessage('Card cvv is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      ach_first_name: {
        required: helpers.withMessage('ACH first name is required', requiredIf(function () {
          return this.cc_or_ach == 'ACH';
        })),
      },
      ach_last_name: {
        required: helpers.withMessage('ACH last name is required', requiredIf(function () {
          return this.cc_or_ach == 'ACH';
        })),
      },
      routing_number: {
        required: helpers.withMessage('Routing number is required', requiredIf(function () {
          return this.cc_or_ach == 'ACH';
        })),
      },
      account_number: {
        required: helpers.withMessage('Account number is required', requiredIf(function () {
          return this.cc_or_ach == 'ACH';
        })),
      },
      account_type: {
        required: helpers.withMessage('Account type is required', requiredIf(function () {
          return this.cc_or_ach == 'ACH';
        })),
      },
      billing_address: { required: helpers.withMessage('Billing address is required', required) },
      billing_city: { required: helpers.withMessage('Billing city is required', required) },
      billing_state: { required: helpers.withMessage('Billing state is required', required) },
      billing_postal: { required: helpers.withMessage('Billing postal is required', required) },
      billing_email: { required: helpers.withMessage('Billing email is required', required) },
    };
  },
  mounted() {
    this.getLocations();
    this.setStatesAndCountries();
  },
  methods: {
    getLocations() {
      const self = this;
      this.$http.get('/location?include_associated=1').then((response) => {
        if (response && response.data && response.data.data && response.data.data.locations) {
          self.locations = response.data.data.locations;
        }

        self.locationsHaveBeenLoaded = true;
        self.setInitialSelectedLocation();
      },
      () => {
        self.locationsHaveBeenLoaded = true;
        // console.log("ERROR GETTING LOCATIONS")
      });
    },
    setStatesAndCountries() {
      const json = this.cwGlobal;
      // const json = require('json-loader!../../../cw.json');
      this.statesAndProvinces = json.states;
      this.countries = json.countries;
      this.updateStatesOrProvinces();
    },
    updateStatesOrProvinces() {
      if (!this.statesAndProvinces) return;
      // this.billing_state = null;
      if (this.billing_country && this.billing_country.id == '1') {
        const usaStates = [];
        for (let i = 0; i < this.statesAndProvinces.length; i++) {
          if (this.statesAndProvinces[i].country_id == '1') {
            usaStates.push(this.statesAndProvinces[i]);
          }
        }

        this.statesOrProvinces = usaStates;
      } else if (this.billing_country && this.billing_country.id == '42') {
        const caProvinces = [];
        for (let j = 0; j < this.statesAndProvinces.length; j++) {
          if (this.statesAndProvinces[j].country_id == '42') {
            caProvinces.push(this.statesAndProvinces[j]);
          }
        }

        this.statesOrProvinces = caProvinces;
      }
    },
    setInitialSelectedLocation() {
      if (this.locations && this.locations.length < 2 && this.locations[0]) {
        const locationId = this.locations[0].id;
        this.selected_locations.push(locationId);
      }
    },
    submitForm() {
      // Check if any locations have been selected
      if (!this.selected_locations || this.selected_locations == null || this.selected_locations.length < 1) {
        this.handleNoSelectedLocations();
        // return;
      }

      this.form_has_been_submitted = true;
      this.v$.$validate();
      this.errorString = '';
      if (!this.v$.$error) {
        this.getForteToken();
      } else {
        this.form_has_been_submitted = false;
        const errors = this.v$.$errors;
        let errorList = '<b>Errors</b>';
        for (let i = 0; i < errors.length; i++) {
          errorList += `<div>- ${errors[i].$message}</div>`;
        }

        errorList += '</ul>';
        const validationErrorList = errorList;
        try {
          this.$wkToast(validationErrorList);
        } catch (error) { console.log(error); }

        this.$nextTick(() => {
          const el = this.$refs.topOfForm;
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    },
    buildForteParams() {
      const forte_token = this.API_LOGIN_ID_TPG;

      const forteParams = { api_login_id: forte_token };

      // If has any payment info, then validate
      if (this.cc_or_ach == 'creditcard') {
        forteParams.card_number = this.card_number;
        forteParams.expire_year = this.expire_year.id;
        forteParams.expire_month = this.expire_month.id;
        forteParams.cvv = this.card_cvv;
      } else {
        forteParams.account_number = this.account_number;
        forteParams.routing_number = this.routing_number;
        forteParams.account_type = this.account_type.id;
      }
      return forteParams;
    },
    getForteToken() {
      const forteParams = this.buildForteParams();

      // eslint-disable-next-line
            forte.createToken(forteParams)
        .success(this.forteTokenCreated)
        .error(this.forteTokenError);

      return false;
    },
    forteTokenCreated(response) {
      this.one_time_token = response.onetime_token;
      const event_data = {
        web_tracking_event_type_id: 11,
        page_name: 'PaymentMethod',
        location_id: this.locationId,
        message: `Forte Token Created: ${response.onetime_token}`,
      };
      this.logForteEvent(event_data);
      this.createPaymentMethod();
    },
    forteTokenError(response) {
      this.form_has_been_submitted = false;
      const event_data = {
        web_tracking_event_type_id: 11,
        page_name: 'PaymentMethod',
        location_id: this.selected_locations,
        message: `Forte Token Error: ${response.response_description}`,
      };
      this.logForteEvent(event_data);
      alert(`There was a problem saving your payment information: ${response.response_description}`);
    },
    logForteEvent(event_data) {
      this.$http.post('api/event', event_data).then(() => {

      });
    },
    paymentTypeLabel() {
      let label = '';
      if (this.cc_or_ach === 'creditcard') {
        label = `CC xx${this.card_number.substr(this.card_number.length - 3)}`;
      } else {
        label = `ACH xx${this.account_number.substr(this.account_number.length - 3)}`;
      }
      return label;
    },
    buildPaymentParams() {
      const paymentMethod = {
        one_time_token: this.one_time_token,
        'location[address][0][category_type]': 'billing',
        'location[address][0][address_1]': this.billing_address,
        'location[address][0][city]': this.billing_city,
        'location[address][0][country_id]': this.billing_country.id,
        'location[address][0][postal]': this.billing_postal,
        'location[contact][0][email]': this.billing_email,
        'location[contact][0][category_type]': 'billing',
      };

      if (this.billing_country.id == '1' || this.billing_country.id == '42') {
        paymentMethod['location[address][0][state_id]'] = this.billing_state.state_id;
      }

      // Set selected Locations
      for (let i = 0; i < this.selected_locations.length; i++) {
        paymentMethod[`relations[${i}][type]`] = 'Location';
        paymentMethod[`relations[${i}][id]`] = this.selected_locations[i];
      }

      if (this.cc_or_ach === 'creditcard') {
        paymentMethod.type = 'card';
        paymentMethod.name = `${this.card_first_name} ${this.card_last_name}`;

        paymentMethod['location[contact][0][first_name]'] = this.card_first_name;
        paymentMethod['location[contact][0][last_name]'] = this.card_last_name;
      } else {
        paymentMethod.type = 'ach';
        paymentMethod.name = `${this.ach_first_name} ${this.ach_last_name}`;

        paymentMethod['location[contact][0][first_name]'] = this.ach_first_name;
        paymentMethod['location[contact][0][last_name]'] = this.ach_last_name;
      }

      return paymentMethod;
    },
    handlePaymentSuccess(response) {
      this.form_has_been_submitted = false;
      if (response.data.success == true) {
        this.$router.push({ path: '/jimmyjohns/payment_update_success' });
      } else if (response.data.code == 200) {
        this.$router.push({ path: '/jimmyjohns/payment_update_success' });
      } else if (response.data.error == true) {
        if (response.data.message) {
          this.errorString = response.data.message;
          try {
            this.$wkToast(this.errorString);
          } catch (error) { console.log(); }
        } else if (response.data.data && response.data.data.fields) {
          this.errorString = this.returnFriendlyErrors(response.data.data.fields);
          try {
            this.$wkToast(this.errorString);
          } catch (error) { console.log(); }
        } else {
          this.errorString = 'An error occurred.';
          try {
            this.$wkToast(this.errorString);
          } catch (error) { console.log(); }
        }
      }
    },
    handlePaymentFailure(response) {
      this.form_has_been_submitted = false;
      if (response.data && response.data.data && response.data.data.api_response && response.data.data.api_response.response && response.data.data.api_response.response.response_desc) {
        this.errorString = `ERROR: ${response.data.data.api_response.response.response_desc}`;
        try {
          this.$wkToast(this.errorString);
        } catch (error) { console.log(error); }
      } else if (response.data && response.data.message) {
        this.errorString = `Error: ${response.data.message}`;
        try {
          this.$wkToast(this.errorString);
        } catch (error) { console.log(`Payment Failure: ${error}`); }
      } else {
        this.errorString = 'Error creating payment. Check your entry and try again.';
        try {
          this.$wkToast(this.errorString);
        } catch (error) { console.log(`Payment Failure: ${error}`); }
      }
    },
    createPaymentMethod() {
      const paymentParams = this.buildPaymentParams();
      const self = this;
      this.$http.post('/payment/jimmyjohns', Querystring.stringify(paymentParams)).then((response) => {
        self.handlePaymentSuccess(response);
      },
      (response) => {
        if (response) self.handlePaymentFailure(response);
      });
    },
    handleNoSelectedLocations() {
      this.no_selected_locations = true;
      const container = this.$el.querySelector('.update_cc');
      container.scrollTop = container.scrollHeight;
    },
    clearModel() {
      this.errorString = '';
      this.cc_or_ach = 'creditcard';
      this.card_number = '';
      this.expire_year = null;
      this.expire_month = null;
      this.card_type = null;
      this.card_cvv = '';
      this.account_number = '';
      this.routing_number = '';
      this.account_type = null;
      this.one_time_token = '';
      this.card_first_name = '';
      this.card_last_name = '';
      this.ach_first_name = '';
      this.ach_last_name = '';
      this.form_has_been_submitted = false;
      this.selected_locations = [];
      this.no_selected_locations = false;
      this.locationsHaveBeenLoaded = false;
    },
    returnFriendlyErrors(errors) {
      let friendlyErrors = '';
      for (const key in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, key)) {
          if (friendlyErrors) {
            friendlyErrors = `${friendlyErrors}<br>- ${errors[key]}`;
          } else {
            friendlyErrors = `- ${errors[key]}`;
          }
        }
      }

      return friendlyErrors;
    },
    listizeErrors(e) {
      let list = "<ul style='text-align: left;margin-top:5px'>";
      for (let i = 0; i < e.length; i++) {
        list = `${list}<li>${e[i]}</li>`;
      }

      list = `${list}</ul>`;
      return list;
    },
  },
  components: {

  },
  computed: {
    filteredMonths() {
      const allMonths = [
        { i: 1, id: '01', name: 'January' },
        { i: 2, id: '02', name: 'February' },
        { i: 3, id: '03', name: 'March' },
        { i: 4, id: '04', name: 'April' },
        { i: 5, id: '05', name: 'May' },
        { i: 6, id: '06', name: 'June' },
        { i: 7, id: '07', name: 'July' },
        { i: 8, id: '08', name: 'August' },
        { i: 9, id: '09', name: 'September' },
        { i: 10, id: '10', name: 'October' },
        { i: 11, id: '11', name: 'November' },
        { i: 12, id: '12', name: 'December' },
      ];

      return allMonths;
    },
    shouldDisplayStates() {
      if (this.billing_country && (this.billing_country.id == '1' || this.billing_country.id == '42')) {
        return true;
      }
      return false;
    },
    expYears() {
      const expYears = [];
      const currentYear = new Date().getFullYear();
      for (let i = currentYear; i < currentYear + 10; i++) {
        const y = { id: `${i}`, name: `${i}` };
        expYears.push(y);
      }
      return expYears;
    },
  },
  watch: {
    selected_locations() {
      if (this.selected_locations && this.selected_locations.length > 0) {
        this.no_selected_locations = false;
      }
    },
  },
};
</script>

<style scoped>
a,
a:hover,
a:visited {
    color: black;
    text-decoration: underline;
}

h4 {
    color: black;
    text-align: center;
    padding-top: 30px;
}

.select-locations-container {
    width: 96%;
    margin: 0 auto;
    border: 1px solid rgb(190, 190, 190);
    border-radius: 3px;
    height: auto;
    max-height: 200px;
    overflow-y: scroll;
    background: white;
}

.update_cc input[type='checkbox'] {
    border: 1px solid #ccc;
    background: white;
    margin-top:13px;
}

.select-locations-row {
    border-bottom: 1px solid #ccc;
    height: 40px;
    line-height: 40px;
    width: 99%;
}

.select-locations-row:hover {
    background: #efefef;
}

.update_cc {
    max-width: 800px;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 50px;
    color: black;
}

.update-cc-header {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    color: #666;
    font-size: 20px;
    clear: both;
    padding-bottom: 30px;
}

.update_cc input[type="text"] {
    border: 1px solid #ccc;
    background: #fff;
    color: #666;
    border-radius: 5px;
    width: 100%;
    height: 36px;
    font-weight: normal;
}

.textarea-holder {
    width: 100%;
    text-align: center;
}

.update_cc textarea {
    clear: both;
    width: 100%;
    margin: 0 auto;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 30px;
}

.invalidField {
    color: rgb(224, 0, 43);
}

.invalidFieldCheck {
    color: rgb(224, 0, 43);
}

.update-cc-button {
    margin-top: 20px;
}

.inlineError.isJj {
    color: rgb(224, 0, 43);
}

.no-locations {
    margin-top: 50px;
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    background: #efefef;
    text-align: center;
}

.form-check-label {
    width: 100%;
    cursor: pointer;
    margin-left:13px;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

.multi-location-sub {
    text-align: center;
    padding: 10px;
}

.multi-location-sub a {
    color: black;
}
</style>
